// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const CourseChapterSingle = () => {
//   // Extracting cchapter_id using regular expressions
//   const location = useLocation();
//   // const cchapter_id = location.pathname.match(/\/class\/(\d+)/);
//   const cchapter_id = location.pathname.match(/\/course-chapter\/(\d+)/)?.[1];

//   const [cchapter, setCchapter] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchCchapter = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/cchapter/${cchapter_id}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setCchapter(data);
//       localStorage.setItem("classData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (cchapter_id) {
//       fetchCchapter();
//     }
//   }, [cchapter_id]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 {/* <div className="editButton">
//                   <Link
//                     to={`/subject/cchapter/upd_cchapter/${cchapter_id}`}
//                     className=" link"
//                   >
//                     Edit
//                   </Link>
//                 </div> */}
//                 <h1 className="title">Chapter Info</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{cchapter?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{cchapter?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{cchapter?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Chapter Name: </span>
//                     <span className="itemValue">{cchapter?.data.name}</span>
//                   </div> */}

//                   <div className="detailItem">
//                     <span className="itemKey">Subjects: </span>
//                     <span className="itemValue">
//                       {cchapter?.data.subject_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">
//                       {cchapter?.data.class_names}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{cchapter?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default CourseChapterSingle;



import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const CourseChapterSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cchapter_id = location.pathname.match(/\/course-chapter\/(\d+)/)?.[1];
  const [cchapter, setCchapter] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchCchapter = async () => {
    try {
      const response = await fetch(`${serverUrl}/cchapter/${cchapter_id}`);
      const data = await response.json();
      setCchapter(data);
      localStorage.setItem("classData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (cchapter_id) {
      fetchCchapter();
    }
  }, [cchapter_id]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Chapter Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Chapter Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Chapter Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Chapter Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {cchapter?.data.name}
                      </h1>
                    </div>
                  </div>
                </div>

                {/* Chapter Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Chapter Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Subjects */}
                    {cchapter?.data.subject_names && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Subjects
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {cchapter.data.subject_names}
                        </p>
                      </div>
                    )}

                    {/* Class */}
                    {cchapter?.data.class_names && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          Class
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {cchapter.data.class_names}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseChapterSingle;